import React, { useEffect, useState, useCallback } from 'react';
import { PrebookingTable, PrebookingFilters } from 'modules/prebookings';
import { byVehicleType } from 'modules/prebookings/sort';
import { getPrebookingForecast, getPrebookings } from 'modules/prebookings/services';

import { mapForecast, createPrebookingsMap } from 'modules/prebookings/utils';

import { useLocalStorage } from 'utils/useLocalStorage';

import { Loading } from 'components/Loading';

const t = {
  empty_filters: 'Please select route and date filter to get the forecast of prebookings',
  empty_forecast: "We don't have forecast ready for that day and route",
  not_allowed: "You don't have permissions to perform this action",
  so_forecast: 'Forecast SOs:',
};

const ForecastModule = ({ forecast }) => {
  if (!forecast || !forecast?.length) {
    return null;
  }

  const forecastTotalSOs = forecast.reduce((acc, { so_forecast }) => acc + so_forecast, 0);

  return (
    <>
      <div>
        {t.so_forecast} {forecastTotalSOs}
      </div>
    </>
  );
};

const PrebookingsSection = ({ className }) => {
  const [fetching, setFetching] = useState(false);
  const [filters, setFilters] = useLocalStorage('prebooking/filters', {});
  const [forecast, setForecast] = useState([]);
  const [prebookings, setPrebookings] = useState([]);

  const handleFiltersChange = useCallback(
    (filter) => {
      setFilters({
        ...filters,
        ...filter,
      });
    },
    [filters, setFilters]
  );

  const prebookingsMap = prebookings.reduce(createPrebookingsMap, {});
  const sortedAndMapedForecast = forecast.map(mapForecast(prebookingsMap)).sort(byVehicleType);

  useEffect(() => {
    const getForecast = async () => {
      const { route, date, vehicle_types } = filters;

      if (!route || !date) {
        return;
      }

      setFetching(true);
      setForecast([]);
      setPrebookings([]);

      try {
        const [forecast, { results: prebookings }] = await Promise.all([
          await getPrebookingForecast({
            route,
            date,
            vehicle_types,
          }),
          await getPrebookings({
            route,
            date,
            vehicle_types,
          }),
        ]);

        setForecast(forecast);
        setPrebookings(prebookings);
      } catch (err) {
        console.error(err);
      } finally {
        setFetching(false);
      }
    };

    getForecast();
  }, [filters]);

  const handleLaunch = useCallback(async () => {
    const { route, date, vehicle_types } = filters;
    const { results: prebookings } = await getPrebookings({
      route,
      date,
      vehicle_types,
    });
    setPrebookings(prebookings);
  }, [filters]);

  const { route, date } = filters || {};

  const hasFilters = !route || !date;

  return (
    <>
      <PrebookingFilters
        filters={filters}
        onChange={handleFiltersChange}
        forecast={<ForecastModule forecast={forecast} />}
      />
      <div className={className}>
        {hasFilters && <div className="empty-filters">{t.empty_filters}</div>}
        {!!fetching && <Loading className="loading" />}
        {!hasFilters && !fetching && !forecast.length && (
          <div className="empty-filters">{t.empty_forecast}</div>
        )}
        {!fetching && (
          <PrebookingTable prebookings={sortedAndMapedForecast} onLaunch={handleLaunch} />
        )}
      </div>
    </>
  );
};

export default PrebookingsSection;
